import React from "react";

import * as S from "./styles";

export const Slide18: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Column>
          <S.Title>créditos | pabllo vittar:</S.Title>
          <S.Text>
            <p>
              Direção criativa: Luciano Schmitz
              <br />
              Foto: Nicole Heiniger
              <br />
              Direção de vídeo: Maurício Kessler
              <br />
              Edição de moda: Flávia Pommianosky e Davi Ramos
              <br />
              Maquiagem: Pabllo Vittar
              <br />
              Hair: Thereza Brown
              <br />
              Produção de moda: Well Santos
              <br />
              Produção de arte e cenografia: Anderson Rodriguez
              <br />
              Camareira: Jô Alcantara <br />
              Contrarregra: Ronaldo Junge
              <br />
              Assistentes de foto: Renato Machado, Bruno Pereira e Fernando Lima
              <br />
              Chefe de elétrica: Sérgio Bronzo
              <br />
              Primeiro assistente de câmera: Cristiano Machado
              <br />
              Operadora de câmera: Dariely Belke
              <br />
              Primeiro assistente de elétrica: Sergio Bronzo Junior
              <br />
              Segundo assistente de elétrica: Rudney Santos
              <br />
              Assistente de beleza: Branca Moura
              <br />
              Produção executiva: Isabela de Paula
              <br />
              Produção executiva de vídeo: Chico Soll
              <br />
              Tratamento de imagem: Thiago Auge
              <br />
              Edição: Rob & Ariel
              <br />
              Digital composer: Fernando Branco
            </p>
          </S.Text>
        </S.Column>
        <S.Column>
          <S.Title>looks do editorial:</S.Title>
          <S.Text>
            <p>
              Pabllo (look 1)
              <br />
              Saia usada como vestido, Walerio Araújo, preço sob consulta.
              Escarpim, Lucas Regal, R$ 320.
            </p>

            <p>
              Pabllo (look 2)
              <br />
              Conjunto de tule, Rober Dognani, R$ 1.200. Corselete, Leandro
              Colognesi, R$ 480. Swiss belt, Madame Sher, R$ 1.020. Botas, Au
              Bottier, R$ 560.
            </p>

            <p>
              Pabllo (look 3)
              <br />
              Conjunto de tule, R$ 1.400, gola dourada, R$ 1.200, cinto dourado,
              R$ 620, tudo Rober Dognani.
            </p>

            <p>
              Pabllo (look abertura da matéria)
              <br />
              Body, R$ 280, e luvas, R$ 159, ambos Allan Lenhel.
            </p>
          </S.Text>
        </S.Column>
      </S.Wrapper>
    </S.Container>
  );
};
